export const customTheme = {
  typography: {
    h1: {
      fontFamily: 'Tiempos Headline',
      fontSize: '38px',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '52px'
    },
    h2: {
      fontFamily: 'Tiempos Headline',
      fontSize: '30px',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '37px'
    },
    h3: {
      fontFamily: 'Tiempos Headline',
      fontSize: '24px',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '37px'
    },
    h4: {
      fontFamily: 'National',
      fontSize: '18px',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '25px'
    },
    h5: {
      fontFamily: 'National',
      fontSize: '15px',
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: '22px'
    },
    h6: {
      fontFamily: 'National',
      fontSize: '10px',
      fontWeight: 500,
      letterSpacing: '2px',
      lineHeight: '13px'
    },
    body1: {
      fontFamily: 'Tiempos Text',
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: '32px'
    },
    body2: {
      fontFamily: 'Tiempos Text',
      fontSize: '16px',
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: '28px'
    },
    button: {
      fontFamily: 'National',
      fontSize: '12px',
      fontWeight: 500,
      letterSpacing: '1.5px',
      lineHeight: '15px',
      textAlign: 'center'
    }
  }
}

export const CHART_COLOR_PALETTE = [
  '#00B286',
  '#05C34B',
  '#F65757',
  '#FFD63B',
  '#4B8DEA',
  '#20B3C7',
  '#B20067',
  '#8520C7',
  '#EA882D',
  '#D0B3F5'
]

export const CHART_COLOR_PALETTE_BY_LEVEL = [
  'orange',
  '#EBAE3B',
  '#21609E',
  '#F65757',
  '#20B3C7',
  '#664649',
  '#1FC2A0',
  '#4B8DEA',
  '#EF5B82',
  '#9469D9',
  '#EA882D'
]

export const PACE_COLOR_PALETTE = {
  behind: '#FFD000',
  onTrack: '#05C34B',
  ahead: '#B1FFDA'
}

export const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left'
  },
  getContentAnchorEl: null
}
